<!--suppress JSPotentiallyInvalidTargetOfIndexedPropertyAccess -->
<template>
    <div>
        <h2 class="titulo">Selecione o prazo e parcela</h2>
        <v-layout class="justify-center">
            <v-flex sm10 md8 lg6>
                <v-tabs id="TabsSituacaoGrupo" v-model="pedido.plano.situacao_grupo" class="pb-5" mobile-break-point="0" fixed-tabs>
                    <v-tab id="TabGrupoNovo" href="#formacao" :disabled="disable_situacao_grupo_novo">Grupo Novo</v-tab>
                    <v-tab id="TabGrupoAndamento" :disabled="disable_situacao_grupo" href="#andamento">Grupo em Andamento</v-tab>
                </v-tabs>
                <v-layout class="justify-center pb-5" v-if="pedido.plano.situacao_grupo === SituacaoGrupo.Andamento">
                    <SlideButton id="SlideTipoNegociacao" :disabled="disable_tipo_negociacao" :values="['Diluição', 'Furo']" v-model="diluicao" />
                </v-layout>
                <p class="text-center opcao-furo" v-if="!diluicao && pedido.plano.situacao_grupo === SituacaoGrupo.Andamento">{{ OpcoesFuroDesc[prazo_parcela_selecionado.opcao_furo] }}</p>
                <div v-if="prazos_parcelas.length > 0">
                    <v-select label="Selecione o prazo: "
                              id="SelectPrazo"
                              :items="prazos_inverse"
                              :item-text="getPrazoLabel"
                              v-model="prazo_parcela_selecionado"
                              return-object
                              outlined>
                    </v-select>
                    <v-layout column v-if="prazos_parcelas.length > 1">
                        <v-flex>
                            <v-slider
                                    id="PrazoSlider"
                                    v-model="prazo_slider"
                                    :max="ultimo_indice"
                                    tick-size="0"
                                    step="1"
                                    height="1"
                                    color="secondary"
                                    track-color="gray"
                                    track-fill-color="secondary"
                                    ticks
                                    always-dirty
                                    thumb-label>
                                <template slot="thumb-label">
                                    <span>{{ prazo_parcela_selecionado.prazo_restante }}</span>
                                </template>
                            </v-slider>
                        </v-flex>
                        <v-flex>
                            <v-layout wrap>
                                <v-flex xs6>
                                    <!--suppress JSPotentiallyInvalidTargetOfIndexedPropertyAccess Aqui não tem risco de não existir o índice 0 na computed pq já é feito um v-if lá em cima prazos_parcelas.length > 0 -->
                                    <p>{{ prazos_inverse[0].prazo_restante }}</p>
                                </v-flex>
                                <v-flex xs6><p class="text-right">{{ prazos_inverse[ultimo_indice].prazo_restante }}</p></v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-select label="Selecione a parcela: "
                              id="parcela"
                              :items="prazos_parcelas"
                              v-model="prazo_parcela_selecionado"
                              :item-text="formatParcela"
                              return-object
                              outlined>
                    </v-select>
                    <v-layout column v-if="filtraValoresRepetidos(prazos_parcelas).length > 1">
                        <v-flex>
                            <v-slider
                                    id="ParcelaSlider"
                                    v-model="parcela_slider"
                                    :max="ultimo_indice"
                                    class="square-thumb"
                                    tick-size="0"
                                    step="1"
                                    height="1"
                                    color="secondary"
                                    track-color="gray"
                                    track-fill-color="secondary"
                                    ticks
                                    always-dirty
                                    thumb-label>
                                <template slot="thumb-label">
                                    <span>{{ prazo_parcela_selecionado.valor | money }}</span>
                                </template>
                            </v-slider>
                        </v-flex>
                        <v-flex>
                            <v-layout wrap>
                                <v-flex xs6><p>{{ prazos_parcelas[0].valor | money }}</p></v-flex>
                                <v-flex xs6>
                                    <p class="text-right">{{ prazos_parcelas[ultimo_indice].valor | money }}</p>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </div>
                <div v-else>
                    <p class="text-center">Nenhuma informação encontrada</p>
                </div>
            </v-flex>
        </v-layout>

        <v-layout class="justify-space-between">
            <v-btn id="ButtonVoltar" text color="secondary" @click="voltar()">Voltar</v-btn>
            <v-btn id="ButtonProsseguir" style="flex: none" color="primary" @click="salvar()" v-if="prazos_parcelas.length > 0">
                Prosseguir
            </v-btn>
        </v-layout>
    </div>
</template>

<script>
  import { OpcoesFuroDesc, SituacaoGrupo, TipoNegociacao } from '@/plugins/constants'
  import { money } from '@/plugins/formatters'
  import { notification } from '@/plugins/helpers'
  import { isBoolean, orderBy } from 'lodash'
  import { mapGetters, mapState } from 'vuex'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  import faturamentoMinimo from '@/mixins/faturamentoMinimo'

  export default {
    name: 'SelecionarPrazoParcela',
    mixins: [faturamentoMinimo],
    props: { value: Object },
    data: () => ({
      errorGroupHasCall: false,
      prazo_parcela_selecionado: {
        prazo_restante: '',
        prazo_original: ''
      },
      disable_tipo_negociacao: false,
      disable_situacao_grupo: false,
      disable_situacao_grupo_novo: false,
      refaz_request: true,
      prazos_parcelas: [],
      reservas_negadas: [],
      pedido: {
        plano: {
          id_plano_venda: 0,
          id_taxa_plano: 9,
          situacao_grupo: SituacaoGrupo.Andamento,
          pz_restante: 0,
          prazo_comercializacao: 0,
          valor_parcela: 0.0,
          tipo_negociacao: TipoNegociacao.Diluido,
          opcao_furo: ''
        },
        bem: {
          id_bem: 0
        },
        grupos: [],
        percentual_minimo_venda: 0,
        percentual_minimo_faturamento: 0
      }
    }),
    computed: {
      ...mapGetters([
        'filial'
      ]),
      ...mapState(['jornada_venda']),
      diluicao: {
        get () {
          return this.pedido.plano.tipo_negociacao === TipoNegociacao.Diluido
        },
        set (diluicao) {
          if (isBoolean(diluicao)) {
            this.pedido.plano.tipo_negociacao = diluicao ? TipoNegociacao.Diluido : TipoNegociacao.Furo
          } else {
            this.pedido.plano.tipo_negociacao = diluicao && diluicao === TipoNegociacao.Diluido ? TipoNegociacao.Diluido : TipoNegociacao.Furo
          }
        }
      },
      SituacaoGrupo: () => SituacaoGrupo,
      OpcoesFuroDesc: () => OpcoesFuroDesc,
      tipo_negociacao () {
        return this.diluicao ? TipoNegociacao.Diluido : TipoNegociacao.Furo
      },
      prazo_slider: {
        get: function () {
          return this.ultimo_indice - this.prazos_parcelas.indexOf(this.prazo_parcela_selecionado)
        },
        set: function (index) {
          this.prazo_parcela_selecionado = this.prazos_parcelas[this.ultimo_indice - index]
        }
      },
      parcela_slider: {
        get: function () {
          return this.prazos_parcelas.indexOf(this.prazo_parcela_selecionado)
        },
        set: function (index) {
          this.prazo_parcela_selecionado = this.prazos_parcelas[index]
        }
      },
      ultimo_indice () {
        return this.prazos_parcelas.length - 1
      },
      prazos_inverse () {
        return [ ...this.prazos_parcelas ].reverse()
      }
    },
    watch: {
      'pedido.plano.situacao_grupo' (val) {
        this.diluicao = true
        if (this.refaz_request) {
          this.getPrazoParcelas()
        }
        if (val === SituacaoGrupo.Formacao) {
          this.refaz_request = false
        }
      },
      diluicao () {
        if (this.refaz_request) {
          this.getPrazoParcelas()
        }
        this.refaz_request = true
      }
    },
    mounted () {
      this.loadModel()
    },
    methods: {
      filtraValoresRepetidos (prazos) {
        return prazos.filter((prazo, index, self) => index === self.findIndex(value => value.valor === prazo.valor))
      },
      formatParcela (item) {
        return money(item.valor)
      },
      getPrazoLabel (item) {
        let grupos = ''
        let nameGrupo = item.grupos.length > 1 ? 'Grupos' : 'Grupo'
        item.grupos.forEach((grupo, index) => {
          if (index === 0) {
            grupos = `${grupo}`
          } else {
            grupos = `${grupos}, ${grupo}`
          }
        })
        if (this.pedido.plano.tipo_negociacao === TipoNegociacao.Diluido) {
          return `${item.prazo_original} (Prazo restante: ${item.prazo} | ${nameGrupo}: ${grupos})`
        }
        return `${item.prazo} (Prazo restante: ${item.prazo_restante} | ${nameGrupo}: ${grupos})`
      },
      loadModel () {
        this.pedido.plano = { ...this.pedido.plano, ...this.value.plano }
        this.pedido.bem = { ...this.pedido.bem, ...this.value.bem }
        this.pedido = { ...this.value, ...this.pedido }
        // Deve-se usar o model do pedido aqui, pois o value pode não vir no formato {plano:..., bem:..., etc}
        if (this.pedido.plano.tipo_negociacao) {
          this.diluicao = this.pedido.plano.tipo_negociacao
        }
        this.getPrazoParcelas()
        this.getLimiteComprometimentoRendaWithRetry()
      },
      async getLimiteComprometimentoRendaWithRetry () {
        let retryCount = 0
        const maxRetries = 3
        if (this.pedido?.cliente?.id_cliente > 0) {
          while (retryCount < maxRetries) {
            try {
              const result = await this.$http.get(`/parametrizacao/load_parametrizacao/limite_comprometimento_renda`)
              if (result.data) {
                this.percentual_minimo_venda = result.data.valor
                break
              }
            } catch (err) {
            }
            retryCount++
          }
        }
      },
      getPrazoParcelas () {
        if (this.pedido.bem.id_bem) {
          let id_regiao_fiscal = 1
          let id_bem = this.pedido.bem.id_bem
          let id_reserva = this.pedido.id_reserva
          let id_grupo = this.pedido.id_grupo
          let id_ponto_venda = this.$session.get('id_ponto_venda')
          let flavor = this.$session.get('flavor')
          let id_unidade_negocio = this.$session.get('id_unidade_negocio')
          let request = null

          if (this.prazo_parcela_selecionado && this.prazo_parcela_selecionado.apenas_reserva) {
            request = this.$http.get('/compra/prazosparcelas', {
              params: {
                ...this.pedido.plano,
                id_bem,
                id_regiao_fiscal,
                id_reserva,
                id_grupo,
                id_ponto_venda,
                flavor,
                id_unidade_negocio,
                apenas_reserva: this.prazo_parcela_selecionado.apenas_reserva
              }
            })
          } else {
            request = this.$http.get('/compra/prazosparcelas', {
              params: {
                ...this.pedido.plano,
                id_bem,
                id_regiao_fiscal,
                id_reserva,
                id_grupo,
                id_ponto_venda,
                flavor,
                id_unidade_negocio
              }
            })
          }

          request.then(res => {
            if (!res.data.msg_erro) {
              this.pedido.grupos = res.data.grupos
              this.prazos_parcelas = orderBy(res.data.prazos_parcelas, [ 'prazo_restante' ]).reverse()
              this.reservas_negadas = res.data.reservas_negadas
              this.refaz_request = this.pedido.plano.tipo_negociacao === res.data.tipo_negociacao
              this.pedido.plano.situacao_grupo = res.data.situacao_grupo
              this.pedido.plano.tipo_negociacao = res.data.tipo_negociacao
              if (this.pedido.id_reserva && res.data.situacao_grupo === SituacaoGrupo.Andamento) { // Se tiver reserva as tab "grupo novo" é bloqueada.
                this.disable_situacao_grupo_novo = true
              } else {
                this.disable_tipo_negociacao = res.data.disable_tipo_negociacao
                this.disable_situacao_grupo = res.data.disable_situacao_grupo
              }

              if (this.reservas_negadas.length > 0) {
                this.pedido.grupos = this.pedido.grupos.filter(grupo => this.reservas_negadas.findIndex(reserva => reserva.grupo === grupo.CD_Grupo) === -1)
              }
              this.pedido.grupos_originais = res.data.grupos_originais
              if (this.prazos_parcelas.length > 0) {
                this.prazo_parcela_selecionado = this.prazos_parcelas[0]
              }
            } else {
              this.prazos_parcelas = []
              this.prazo_parcela_selecionado = {}
              if (!this.errorGroupHasCall) {
                notification('error', res.data.msg_erro, 'Não foi possível buscar os prazos/parcelas!')
                this.errorGroupHasCall = true
              }
            }
          })
            .catch(err => notification('error', err, 'Não foi possível buscar os prazos/parcelas!'))
        }
      },
      salvar () {
        if (this.pedido?.cliente?.id_cliente > 0 && this.percentual_minimo_venda > 0) {
          if (this.pedido.cliente.pessoa === 'fisica') {
            let renda = this.pedido.cliente.renda
            let resul = (this.prazo_parcela_selecionado.valor / renda) * 100
            if (resul > this.percentual_minimo_venda) {
              return notification('warning', 'O valor da parcela selecionada compromete mais do que ' + this.percentual_minimo_venda + '% da renda, venda não permitida.')
            }
          }
        }

        if (!this.verificarFaturamentoParaVenda()) {
          return
        }

        this.pedido.plano.grupos = this.prazo_parcela_selecionado.grupos
        this.pedido.plano.apenas_reserva = this.prazo_parcela_selecionado.apenas_reserva
        this.pedido.plano.pz_restante = this.prazo_parcela_selecionado.prazo_restante
        this.pedido.plano.prazo_comercializacao = this.prazo_parcela_selecionado.prazo_original
        this.pedido.plano.valor_parcela = this.prazo_parcela_selecionado.valor
        this.pedido.plano.id_tipo_venda = this.prazo_parcela_selecionado.id_tipo_venda
        this.pedido.plano.opcao_furo = this.prazo_parcela_selecionado.opcao_furo

        this.sendAnalytics()
        this.$emit('input', { ...this.pedido })
        this.$emit('nextPage')
      },
      sendAnalytics () {
        sendAnalyticsEvent(this.$gtag, 'grupo_prazoParcela', {
          tipo_grupo: this.pedido.plano.situacao_grupo,
          modelo_plano: this.pedido.plano.tipo_negociacao,
          qtd_parcelas: this.pedido.plano.pz_restante,
          valor_parcela: this.pedido.plano.valor_parcela,
          grupo: this.pedido.plano.grupos.join(', '),
          source_menu: this.jornada_venda
        })
      },
      voltar () {
        delete this.pedido.plano
        this.$emit('prevPage')
      }
    }
  }
</script>

<style>
  .opcao-furo {
    color: var(--primary);
    text-transform: uppercase;
    font-weight: bold;
    font-size: 1.2rem;
  }
</style>
